<template>
    <section class="ui-user-check">
        <input type="radio" :id="'check-user'+id" name="user-selected" @change="onChange()" :value="data" :checked="checked">
        <label :for="'check-user'+id">
            <img :src="avatar">
        </label>
        <div class="infos">
            <div class="name">{{name}}</div>
            <div class="role">{{role}}</div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        props: {
            avatar: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            role: {
                type: String,
                required: true,
            },
            data: {},
            value: {},
        },
        computed:{
            checked(){
                return this.data * 1 === this.value * 1 ? 'checked' : ''
            }
        },
        data() {
            return {
                id: null,

            }
        },
        methods: {
            onChange(){
                this.$emit('input', this.data)
            }
        },
        created(){
            this.id = this._uid
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>    
